import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import PersonRemoveOutlinedIcon from '@mui/icons-material/PersonRemoveOutlined';
import { useTranslation } from 'react-i18next';

const RemoveCompanionDialog = ({ companion, loading = false, onClose, onConfirm, open }) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={loading ? undefined : onClose} fullWidth maxWidth="xs">
      <DialogTitle>{t('companions.removeDialog.title')}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {t('companions.removeDialog.body', {
            name: companion?.displayName || t('profile.defaults.displayName'),
          })}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button disabled={loading} onClick={onClose}>
          {t('common.cancel')}
        </Button>
        <Button
          color="secondary"
          disabled={loading}
          startIcon={<PersonRemoveOutlinedIcon />}
          variant="contained"
          onClick={onConfirm}
        >
          {loading ? t('companions.removeDialog.removing') : t('companions.removeDialog.confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RemoveCompanionDialog;
